"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHrSmallSpinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const SHrSmallSpinner_module_scss_1 = __importDefault(require("./SHrSmallSpinner.module.scss"));
const SHrSmallSpinner = (p) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ className: SHrSmallSpinner_module_scss_1.default.spinner, viewBox: "0 0 66 66", xmlns: "http://www.w3.org/2000/svg" }, p === null || p === void 0 ? void 0 : p.options, { children: (0, jsx_runtime_1.jsx)("circle", { className: SHrSmallSpinner_module_scss_1.default.path, fill: "none", strokeWidth: "6", strokeLinecap: "round", cx: "33", cy: "33", r: "30" }) })));
};
exports.SHrSmallSpinner = SHrSmallSpinner;
